"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxReadyTimeout = exports.formIframeDataHook = exports.formPathname = void 0;
exports.formPathname = "card-form";
// it shouldn't moved to utils/DataHook.ts since we don't need any other data-hooks in public component (to reduce bundle size)
exports.formIframeDataHook = 'cc-form-public-frame';
exports.maxReadyTimeout = 30 * 1000;
//# sourceMappingURL=constants.js.map